import axios from "axios";
import moment from "moment";
import React from "react";
import { useQuery } from "react-query";
import { serverUrl } from "../../nestserver";

/**
 * "Perfect attendance" appreciation for the student / parent home screen.
 * Shows one card per awarded child for last month's 100% attendance and
 * renders nothing when there is no award.
 */
const AttendanceAppreciationBanner = ({ kind = "student" }) => {
  const isStaff = kind === "staff";
  const { data } = useQuery(["attendance-appreciation-me", kind], async () => {
    const path = isStaff ? "/attendance-appreciation/staff/me" : "/attendance-appreciation/me";
    const res = await axios.get(`${serverUrl}${path}`, {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data?.result;
  });

  const awards = data?.data || [];
  if (!awards.length) return null;

  const monthLabel = moment(data.month, "YYYY-MM").format("MMMM YYYY");

  return (
    <div className="flex flex-col gap-3 pt-6">
      {awards.map((a) => {
        const name = `${a.student?.first_name || ""} ${
          a.student?.last_name || ""
        }`.trim();
        return (
          <div
            key={a._id}
            className="flex items-center gap-4 rounded-2xl px-6 py-4"
            style={{
              background: "linear-gradient(90deg, #fff7e6 0%, #fff1e6 100%)",
              border: "1px solid #ffd8a8",
            }}
          >
            <div style={{ fontSize: 36 }} role="img" aria-label="star">
              🌟
            </div>
            <div>
              <div className="text-lg font-semibold" style={{ color: "#c2410c" }}>
                Perfect attendance in {monthLabel}!
              </div>
              <div className="text-sm text-gray-700">
                {isStaff
                  ? `Thank you for your dedication — on time on all ${a.working_days} working days.`
                  : `Congratulations ${name}${
                      a.class?.name ? ` (${a.class.name})` : ""
                    } — present on all ${a.total_days} school days. Keep it up!`}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AttendanceAppreciationBanner;
